import { render, staticRenderFns } from "./CommentDetail.vue?vue&type=template&id=0441f885&scoped=true"
import script from "./CommentDetail.vue?vue&type=script&lang=js"
export * from "./CommentDetail.vue?vue&type=script&lang=js"
import style0 from "./CommentDetail.vue?vue&type=style&index=0&id=0441f885&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0441f885",
  null
  
)

export default component.exports